import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=ed6d4d5c&scoped=true&"
import script from "./Environments.vue?vue&type=script&lang=js&"
export * from "./Environments.vue?vue&type=script&lang=js&"
import style0 from "./Environments.vue?vue&type=style&index=0&id=ed6d4d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d4d5c",
  null
  
)

export default component.exports